const intl = new Intl.DateTimeFormat('cs-CZ', {
	timeStyle: 'short',
})

export const dateToTime = (date: string | Date) => {
	const input = new Date(date)

	return intl.format(input)
}
